import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";

import "./broadcastAppDownload.css";

const BroadcastAppDownload = () => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#4867a5",
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          px: 5,
        }}
      >
        <Container maxWidth="sm" className="broadcast-download-container">
          <Typography
            className="broadcast-download-title"
            sx={{ fontSize: "1.7rem", fontWeight: "700" }}
            align="center"
            color="text.primary"
            gutterBottom
          >
            어디서든 언제든 빠르게, 이지웰 라이브
          </Typography>
          <Typography
            className="broadcast-download-subtitle"
            align="center"
            color="text.secondary"
            sx={{ fontSize: "1.3rem", mb: 0 }}
          >
            지금 바로 초저지연 송출앱을 경험하세요.
          </Typography>
          <Stack
            sx={{ pt: 4 }}
            direction="row"
            spacing={2}
            justifyContent="center"
          >
            <a
              target="_blank"
              className="fixed-download-button"
              id="header-download-button-android"
              href="https://ezwelliveappdownload.s3.ap-northeast-2.amazonaws.com/apk/app-release.apk"
            >
              <img
                className="fixed-google-play"
                alt="android app"
                src="/images/icon_play store_.svg"
              />
              <div className="fixed-download-text">Android</div>
            </a>
            <a
              target="_blank"
              className="fixed-download-button"
              id="header-download-button-ios"
              href="https://apps.apple.com/kr/app/%EC%9D%B4%EC%A7%80%EC%9B%B0-%EB%9D%BC%EC%9D%B4%EB%B8%8C-%EC%86%A1%EC%B6%9C/id6760103031"
            >
              <img
                className="fixed-ios"
                alt="ios app"
                src="/images/icon_Apple_.svg"
              />
              <div className="fixed-download-text">iOS</div>
            </a>
          </Stack>
        </Container>
        {/* </Grid> */}
      </Box>
    </>
  );
};

export default BroadcastAppDownload;
